import React, {useState, useEffect} from "react";
import { useTranslation } from "react-i18next";
import CircularProgress from '@mui/material/CircularProgress';
import { ExportToExcel } from "../../../providers/export-excel";
import { withRouter } from "../../../providers/withRouter";
import { AaffListPropertie, AaffListPropertieExport, getChildrenAaffs } from "../../../services";
import { estadoServicio, ventaMasReciente } from "../../../functions/funciones";

const ListadoFincas = (props) => {
    const { t } = useTranslation('properties');
    const [fincas, setFincas] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const fetchData = async ({offset, limit} ={}) => {
        setIsLoading(true)

        const hijosResp = await getChildrenAaffs(props.aaff_id, { params: { page: 1, limit: 1000 } });
        const oficinas = Array.isArray(hijosResp?.data) ? hijosResp.data : [];
        const oficinaMap = new Map(oficinas.map(o => [o.id, o.razonSocial]));
        const aaff_ids = [props.aaff_id, ...oficinas.map(o => o.id)];
        const esPadre = oficinas.length > 0;

        const payload = {
        filtros: { aaff_ids },
        params: { page: offset, limit },
        };
        const response = await AaffListPropertieExport(payload)
        const data = response;

        let num = 0
        data?.forEach( l => {
            num += l?.workcenters?.length >0 ? l?.workcenters?.length : 1
        });
        let f = [];
        data?.forEach(e => {
            const ventaCae = ventaMasReciente(e?.sales, [1,3]);
            const ventaSpa = ventaMasReciente(e?.sales, [6,7]);
            if (!ventaCae?.detailsCae?.length && !ventaSpa?.detailsCae?.length) return;

            let servicios = "";
            if (ventaCae) {
                servicios = "CAE";
            } else if (ventaSpa) {
                servicios = "SPA";
            }

            const oficina = e?.aaff?.id === props.aaff_id
                ? "Sin oficina"
                : (oficinaMap.get(e?.aaff?.id) || "Sin oficina");

            let fincas = {
                razonSocial:e.razonSocial,
                nif: e.nif,
                direccion: e.direccion,
                municipio: e.municipio,
                provincia: e.provincia,
                ...(esPadre && { oficina }),
                proveedores: (ventaCae || ventaSpa) && e.proveedores !== 0 && e.proveedores !== false
                    ? (e.suppliers?.filter(o => o.status === true).length ?? 0)
                    : "No tiene",
                servicios: servicios,
                estado_cae: estadoServicio(e?.ultimoEstadoCaeVenta, t),
            }

            if(e.workcenters.length > 0 ){
                e.workcenters.map( ct => {
                    let data = {
                        razonSocial:ct.razonSocial,
                        nif: e.nif,
                        ...(esPadre && { oficina }),
                    }
                    f.push(data)
                })
            }else{
                f.push(fincas)
            }
            setIsLoading(false)
            setFincas(f)
        })
    }

    useEffect(() => {
        if(props.aaff_id) fetchData()
    },[])
    
    return ( 
        <>
            {!isLoading ?
                <ExportToExcel apiData={fincas} fileName={t('management.propertiesListFileName') + " " + props.params.nif} />
            :
                <span className='bigBtn' style={{ cursor:'context-menu' }}><CircularProgress style={{color:'#fff', width:'16px', height: '16px', marginRight: '10px'}} /> {t('management.generatingList')}</span>
            }
        </>
     );
}
 
export default withRouter(ListadoFincas);